import { data } from '../../svg/Note/data';
import { makeIcon } from '../makeIcon';

export const Note = makeIcon(data, 'note', 'Note');

export default Note;
